import "./style.css";
import React, { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { IoCopyOutline, AiOutlineCheckCircle } from "react-icons/all";

function DepositInstructions() {
  const [copied, setCopied] = useState(false);
  const copy = () => setCopied(true);
  const [copied1, setCopied1] = useState(false);
  const copy1 = () => setCopied1(true);
  const [copied2, setCopied2] = useState(false);
  const copy2 = () => setCopied2(true);
  const [copied3, setCopied3] = useState(false);
  const copy3 = () => setCopied3(true);

  const data = [
    {
      bank: "BKT",
      nr: "1906565627031134",
      state: copied,
      copyText: copy,
      link: "https://ebank.bkt-ks.com/ebanking/login.html",
      link1: "https://ebank.bkt-ks.com/ebanking-business/login.html",
    },
    {
      bank: "BPB",
      nr: "1300001002074205",
      state: copied1,
      copyText: copy1,
      link: "https://www.banka-ks.com/BPB/Account/Login",
    },
    {
      bank: "NLB",
      nr: "1701001012338968",
      state: copied2,
      copyText: copy2,
      link: "https://nlb.banka-ks.com/Account/Login",
    },
    {
      bank: "BEK",
      nr: "1401000000737379",
      state: copied3,
      copyText: copy3,
      link: "https://ebanking.bekonomike.com/#/login",
    },
  ];
  return (
    <div id="wrapper-page">
      <div className="deposit_container">
        <div className="row">
          <div className="col-12 deposit_text">
            <h4>
              Emetimin e parase elektronike ne llogarine ne Capital Pay mund te
              beni ne disa menyra:
            </h4>
            <h4>
              Mbushja e llogarise pa provizion ne zyret dhe agjentet e IFJB
              Capital ne mbi 160 lokacione ne mbare Kosoven. IFJB Capital do te
              beje shtimin e parase elektronike sapo ti pranoje parate nga ana
              juaj. Mjetet tuaja jane te sigurta dhe ne dispozicionin tuaj ne
              cdo kohe dhe mund ti terhiqni kurdo qe deshironi ne ndonje dege
              apo agjent te IFJB Capital.
            </h4>
            <h5>
              Per mbushjen e llogarise duhet te keni nje dokument Identifikimi
              valid si:
            </h5>
            <ul>
              <li>1. Leternjoftim, Pasaporte apo Patent Shofer</li>
              <li>
                2. Mbushja e llogarise permes transferit bankar mund te behet
                nga te gjitha bankat duke dhene pershkrimin si ne vijim:
                <ul>
                  <li>
                    Numrin e telefonit dhe Emrin dhe Mbiemrin (te cilin e
                    posedoni ne aplikacion)
                  </li>
                  <li>
                    Qe transferi te jete pa pagese, keni parasysh te zgjedhni
                    banken e njejte me banken ne te cilen posedoni llogarine
                    tuaj:
                    <ul className="bankat">
                      {data?.map((item) => (
                        <li>
                          <a
                            href={item.link}
                            rel="noreferrer"
                            target="_blank"
                            style={{ color: "#000", textDecoration: "none" }}
                          >
                            {item.bank}: {item.nr}
                          </a>

                          <CopyToClipboard
                            text={item.nr}
                            onCopy={() => item.copyText()}
                          >
                            {item.state ? (
                              <div className="checked">
                                <AiOutlineCheckCircle
                                  style={{ fontSize: 22 }}
                                />
                                Copied to clipboard
                              </div>
                            ) : (
                              <IoCopyOutline
                                style={{ fontSize: 22, cursor: "pointer" }}
                              />
                            )}
                          </CopyToClipboard>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DepositInstructions;
